module.exports = __webpack_public_path__ + "img/ic_mpe_time30_press.019f8116.png";